module.exports = __webpack_public_path__ + "4f0b00937d985ea8d5f04056aab7f652.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/css/res/fonts/AvenirNext/cbc021cc-b96f-4c82-ba0d-59cb0b7449c0.ttf
// module id = 1118
// module chunks = 0